import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const AffordableEcommerceWebsiteDesignInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Affordable E-commerce Website Design in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Cost-Effective Online Stores</Subheading>}
        heading={
          <Heading>
            Affordable{" "}
            <span tw="text-primary-500">E-commerce Website Design</span> in Al
            Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset offers affordable e-commerce website design in **Al
            Barsha**, delivering high-quality, user-friendly online stores that
            fit your budget. Launch your business online without breaking the
            bank.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Budget e-commerce on laptop
          "https://images.unsplash.com/photo-1617042375876-a13e36732a04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Budget planning with calculator
          "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Person working on budget website
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Get Started Now"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Budget-Friendly E-commerce Solutions"
        description="We provide top-tier designs at affordable prices."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Cost-Effective Designs",
            description: "High-quality stores at low costs.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Quick Turnaround",
            description: "Launch in days, not weeks.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Platform Flexibility",
            description: "Shopify, WooCommerce, and more.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Payments",
            description: "Safe transactions for trust.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Responsive",
            description: "Optimized for all devices.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted in Al Barsha",
            description: "Proven local expertise.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Deliver</Subheading>}
        heading="Our Affordable Design Process"
        description={
          <Description>
            We create cost-effective e-commerce stores with precision:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Understand your budget and goals.</li>
              <li>Design: Craft visually appealing, functional stores.</li>
              <li>Development: Integrate essential features affordably.</li>
              <li>Testing: Ensure performance and usability.</li>
              <li>Launch: Deploy your store swiftly.</li>
              <li>Support: Provide ongoing maintenance.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Cost-effective planning
          "https://images.unsplash.com/photo-1472289065668-ce650ac443d2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Small business in Dubai
          "https://images.unsplash.com/photo-1577401239170-897942555fb3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Budget e-commerce shopping
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="Affordable E-commerce Wins"
        description="Our budget-friendly stores deliver results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Cost Savings",
            description: "Saved clients 30% on design costs.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Deployment",
            description: "Stores live in under 10 days.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Happy Clients",
            description: "95% satisfaction rate.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Launch?</Subheading>}
        heading="Affordable E-commerce Website Design in Al Barsha"
        description={
          <Description>
            MilaajBrandset provides affordable e-commerce website design in Al
            Barsha, blending quality and value. Contact us to build your online
            store today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Small business team meeting
          "https://images.unsplash.com/photo-1537476102677-80bac0ab1d8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Dubai marketplace
          "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1080&q=80", // Budget handshake deal
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
